export class TelepathyFormData extends FormData {
    constructor(namespace) {
        super();
        this.namespace = namespace;
    }

    append(key, value) {
        super.append(`${this.namespace}[${key}]`, value);
        return this;
    }
}
